
<!-- // https://vuejs.org/v2/guide/components-custom-events.html#Binding-Native-Events-to-Components -->
<template>
  <div class="relative mt-8 mb-4">
    <div class="flex items-center justify-between w-full mb-2">
      <div class="flex items-center justify-start flex-grow-0 flex-shrink">
        <span class="relative inline-block w-1 h-6">
          <span class="absolute left-0">Disagree</span>
        </span>
        <!--
        <span class="inline-block w-8 h-8">
          <slot name="left">
            <svg-icon icon="sad" size="8">Strongly Disagree</svg-icon>
          </slot>
        </span>
        -->
      </div>
      <div class="flex items-center justify-center flex-grow flex-shrink mx-auto">
        <span class="relative inline-block w-1 h-6">
          <span class="absolute left-50" style="transform:translateX(-50%)">Neutral</span>
        </span>
        <!--
        <span class="inline-block w-8 h-8">
          <slot name="middle">
            <svg-icon icon="straight-face" size="8">Neither Agree nor Disagree</svg-icon>
          </slot>
        </span>
        -->
      </div>
      <div class="flex items-center justify-end flex-grow-0 flex-shrink">
        <span class="relative inline-block w-1 h-6">
          <span class="absolute right-0">Agree</span>
        </span>
        <!--
        <span class="inline-block w-8 h-8">
          <slot name="right">
            <svg-icon icon="smile" size="8">Strongly Agree</svg-icon>
          </slot>
        </span>
        -->
      </div>
    </div>
    <div>
      <input
        @mousedown="grab = true"
        @mouseup="grab = false"
        :class="{
          'mousedown': grab,
        }"
        :disabled="locked"
        class="slider"
        ref="slider"
        type="range"
        v-bind="$attrs"
        :value="proxyValue"
        @change="update"
        @input="update"
      />
    </div>
    <input type="text" class="invisible hidden"
      @input="$emit('update', $event.target.value)"
      v-on="$listeners"

    />
  </div>
</template>

<script>


export default {

  props: ['locked', 'value'],
  model: {
    event: 'update',
  },
  data() {
    return {
      proxyValue: 5,
      grab: false
    }
  },
  mounted() {
    this.proxyValue = this.value
  },
  methods: {
    update(e) {
      // Thanks IE11
      this.proxyValue = this.$refs.slider.value
      this.$emit('update', this.$refs.slider.value )
    }
  }
}
</script>

<style lang="scss" scoped>
// Styling Cross-Browser Compatible Range Inputs with Sass
// Github: https://github.com/darlanrod/input-range-sass
// Author: Darlan Rod https://github.com/darlanrod
// Version 1.5.2
// MIT License

$track-color: theme("colors.lightgrey-e.default");
$thumb-color: var(--theme-highlight, rgb(60, 156, 215));

$thumb-radius: 14px;
$thumb-height: 28px;
$thumb-width: 28px;
$thumb-border-width: 3px;
$thumb-border-color: #fff;

$track-width: 100%;
$track-height: 8px;
$track-shadow-size: 1px;
$track-shadow-blur: 1px;
$track-shadow-color: $track-color;
$track-border-width: 2px;
$track-border-color: $track-color;

$track-radius: 4px;
$contrast: 5%;

$ie-bottom-track-color: theme("colors.grey");

@mixin shadow($shadow-size, $shadow-blur, $shadow-color) {
  box-shadow: $shadow-size $shadow-size $shadow-blur $shadow-color,
    0 0 $shadow-size lighten($shadow-color, 5%);
}

@mixin track {
  cursor: default;
  height: $track-height;
  transition: all 0.2s ease;
  width: $track-width;
  border-radius: $track-radius;
}

@mixin thumb {
  background: $thumb-color;
  border: $thumb-border-width solid $thumb-border-color;
  border-radius: $thumb-radius;
  box-sizing: border-box;
  cursor: grab;
  height: $thumb-height;
  width: $thumb-width;
}

[type="range"] {
  -webkit-appearance: none;
  background: $track-color;
  margin: $thumb-height / 2 0;
  width: $track-width;
  border-radius: $track-radius;

  &::-moz-focus-outer {
    border: 0;
  }

  &:focus {
    outline: 0;
  }

  &::-webkit-slider-runnable-track {
    @include track;
    background: $track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: $track-radius;
  }

  &::-webkit-slider-thumb {
    @include thumb;
    -webkit-appearance: none;
    margin-top: (
      (-$track-border-width * 2 + $track-height) / 2 - $thumb-height / 2
    );
  }

  &::-moz-range-track {
    @include track;
    background: $track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: $track-radius;
    height: $track-height / 2;
  }

  &::-moz-range-thumb {
    @include thumb;
  }

  &::-ms-track {
    @include track;
    background: transparent;
    border-color: transparent;
    border-width: ($thumb-height / 2) 0;
    color: transparent;
  }

  &::-ms-fill-lower {
    background: $ie-bottom-track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: ($track-radius * 2);
  }

  &::-ms-fill-upper {
    background: $track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: ($track-radius * 2);
  }

  &::-ms-thumb {
    @include thumb;
    margin-top: $track-height / 4;
  }

  // Doesn't work - must be a chrome rendering / hover issue.
  // &.mousedown {
  //   &::-webkit-slider-thumb,
  //   &::-moz-range-thumb,
  //   &::-ms-thumb,
  //   &::-webkit-slider-runnable-track,
  //   &::-ms-fill-lower,
  //   &::-ms-fill-upper {
  //     cursor: grabbing !important;
  //   }
  // }

  &:disabled {
    &::-webkit-slider-thumb,
    &::-moz-range-thumb,
    &::-ms-thumb,
    &::-webkit-slider-runnable-track,
    &::-ms-fill-lower,
    &::-ms-fill-upper {
      cursor: not-allowed;
    }
  }
}
</style>
